import postAPI from './postAPI.js'

export default async function postDeleteTaskInstance(body) {
    const data = await postAPI('admin/taskinstances/delete', body);
    return data;
}
